import React from 'react';
import PropTypes from 'prop-types';
import {
	ListItem,
	Grid,
	Typography,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Box,
	useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { ToggleRPC, useIsDesktop } from 'components/utilities';
import { DIRECTIONS } from '../../../../helpers';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

const PolicyListItem = ({ title, content }) => {
	const { direction } = useTheme();

	const isDesktop = useIsDesktop();

	const iconSize = isDesktop ? 'large' : 'default';
	const iconButtonSize = isDesktop ? 'medium' : 'small';

	const textStyles = !isDesktop ? { fontSize: 16 } : null;

	return (
		<ToggleRPC>
			{({ on, toggle }) => (
				<>
					<Dialog open={on} onClose={toggle} fullWidth maxWidth="md">
						<DialogTitle>
							<Box display="flex" justifyContent="flex-end">
								<IconButton onClick={toggle} size={iconButtonSize}>
									<CloseIcon fontSize={iconSize} />
								</IconButton>
							</Box>
						</DialogTitle>
						<DialogContent>{content}</DialogContent>
					</Dialog>
					<ListItem button onClick={toggle}>
						<Grid
							container
							spacing={2}
							justify="space-between"
							alignItems="center"
						>
							<Grid item xs="auto">
								<Typography style={textStyles}>{title}</Typography>
							</Grid>
							<Grid item xs="auto">
								{direction === DIRECTIONS.LTR ? (
									<KeyboardArrowRightIcon fontSize={iconSize} />
								) : (
									<KeyboardArrowLeftIcon fontSize={iconSize} />
								)}
							</Grid>
						</Grid>
					</ListItem>
				</>
			)}
		</ToggleRPC>
	);
};

PolicyListItem.propTypes = {
	title: PropTypes.string,
	content: PropTypes.node,
};

export default PolicyListItem;
